import * as Yup from 'yup'



export const validationSchemas = (recepcionar, opcionRadio) => {
   
  let validationObject = { };
 
 
  validationObject["estadoCaso"] = Yup.string().required('Este campo es obligatorio.');
  
  if (recepcionar == 200003) {//Recepcionado con Pendientes
    validationObject["observacion"] = Yup.string().required('Este campo es obligatorio.');
  }
  
  if (opcionRadio==2) {
    validationObject["flujoGestion"] = Yup.string().required('Este campo es obligatorio.');
  }
  return Yup.object().shape(validationObject);
}

